import React from 'react';

const confettiImage = require("./imgs/Confetti.png");

const Success = () => {
  return (
    <div className="pt-3">
      <div className="mb-4 flex items-center justify-center min-h-[250px]">
        <div className='flex flex-col items-center justify-center text-center gap-2'>
          <div className="w-15 h-15 md:w-[72px] md:h-[72px] flex items-center justify-center">
            <img
              src={confettiImage}
              height={32}
              width={32}
              alt="icon"
              className="w-8 h-8 object-contain align-middle"
            />
          </div>
          <h2 className="text-lg font-semibold text-white mb-0 font-montserratBold">
            Your order has been submitted
          </h2>
          <p className="text-lg text-white font-light font-myriadProRegular max-w-[350px] leading-4">
            Someone will reach out to you as soon as possible.
          </p>
        </div>
      </div>
    </div>
  );
};

Success.propTypes = {};

export default Success;
